import { connect } from 'react-redux'
import Pairings from '../../components/content/pairings'
import { toggleRoundOptions } from '../../actions/index'

// const mapStateToProps = (state) => {}

const mapDispatchToProps = (dispatch, ownProps) => ({
  toggleRoundOptions: (url, option, roundId, data) => dispatch(toggleRoundOptions(ownProps.widgetId, url, option, roundId, data)),
  refresh: () => dispatch(ownProps.refresh),
})

export default connect(
  null,
  mapDispatchToProps,
)(Pairings)
